import React, { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFull } from "tsparticles";
import './Splash.css'; // Pastikan CSS kamu sudah mencakup class flash dan about

const Flash = ({ title = "XYRONS", subtitle = "HUB", info = "LOADING ASSETS...", onFinished, isAboutPage = false }) => {
    const [isFading, setIsFading] = useState(false);
    const [showContent, setShowContent] = useState(false);
    const [init, setInit] = useState(false);

    // 1. Inisialisasi Engine Particles
    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadFull(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    // 2. Logika Timer Flash
    useEffect(() => {
        const fadeTimer = setTimeout(() => {
            setIsFading(true);
        }, 2500);

        const timer = setTimeout(() => {
            if (isAboutPage) {
                setShowContent(true); // Jika ini halaman about, munculkan kontennya
            } else {
                onFinished(); // Jika splash awal, jalankan fungsi selesai
            }
        }, 3000);

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(timer);
        };
    }, [onFinished, isAboutPage]);

    // Konfigurasi Tema & Partikel
    const config = {
        appName: "XYRONS HUB",
        developer: "RONY SAPUTRA",
        theme: { primary: "#28a745" }
    };

    const particlesOptions = {
        background: { color: { value: "transparent" } },
        fpsLimit: 60,
        interactivity: {
            events: { onHover: { enable: true, mode: "grab" } },
            modes: { grab: { distance: 150 } },
        },
        particles: {
            color: { value: config.theme.primary },
            links: {
                color: config.theme.primary,
                distance: 120,
                enable: true,
                opacity: 0.2,
            },
            move: { enable: true, speed: 1 },
            number: { density: { enable: true, area: 800 }, value: 50 },
            size: { value: { min: 1, max: 2 } },
        },
    };

    // TAMPILAN 1: Konten About (Muncul setelah loading 3 detik)
    if (showContent && isAboutPage) {
        return (
            <div className="about-page-container">
                {init && <Particles id="tsparticles" options={particlesOptions} className="particles-bg" />}
                <div className="about-content-wrapper">
                    <h2 className="about-title" style={{ color: config.theme.primary }}>
                        ABOUT {config.appName}
                    </h2>
                    <div className="animated-card">
                        <h3 style={{ color: config.theme.primary, marginBottom: '15px' }}>{config.developer}</h3>
                        <p style={{ color: '#888', fontSize: '14px' }}>
                            Platform AI Community pertama di Medan. Membangun masa depan teknologi bersama.
                        </p>
                        <div className="tag-container" style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                            <span style={{ border: `1px solid ${config.theme.primary}`, padding: '5px', fontSize: '10px', color: config.theme.primary }}>V.2.0.4</span>
                            <span style={{ border: `1px solid ${config.theme.primary}`, padding: '5px', fontSize: '10px', color: config.theme.primary }}>STABLE</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // TAMPILAN 2: Animasi Flash (Loading)
    return (
        <div className={`flash-overlay ${isFading ? 'fade-out' : ''}`}>
            <div className="flash-container">
                <div className="flash-logo-box">
                    <img src="/logo-rony.png" alt="Logo" className="flash-logo-icon" />
                </div>
                <h1 className="flash-title">
                    {title} <span>{subtitle}</span>
                </h1>
                <p className="flash-info-text">{info}</p>
                <div className="flash-loader-track">
                    <div className="flash-loader-bar"></div>
                </div>
            </div>
        </div>
    );
};

export default Flash;